import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Drawer, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import styled, { css } from 'styled-components';

export const StyledDrawer = styled(Drawer)`
  .MuiListItem-button:hover {
    background-color: rgba(226, 54, 14);
  }
  .MuiDrawer-paper {
    top: auto;
    background-color: ${({ theme }) => theme.palette.primary.main};
    white-space: nowrap;
    padding-top: 90px;
    overflow-x: hidden;
    transition: ${({ theme }) =>
      theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      })};
    @media only screen and (max-width: 600px) {
      padding-top: 120px;
    }
    ${({ open }) =>
      open
        ? css`
            width: 20%;
            @media only screen and (max-width: 992px) {
              width: 30%;
            }
            @media only screen and (max-width: 768px) {
              width: 35%;
            }
            @media only screen and (max-width: 600px) {
              width: 60%;
            }
            @media only screen and (max-width: 380px) {
              width: 80%;
            }
          `
        : css`
            width: 40px;
            @media only screen and (max-width: 2900px) {
              width: 60px;
            }
            
            @media only screen and (max-width: 1600px) {
              width: 55px;
             
            }
            @media only screen and (max-width: 1400px) {
              width: 45px
             
            }
           
            @media only screen and (max-width: 600px) {
              width: 0;
            }
          `};
  }
  .MuiListItem-gutters {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const StyledListItem = styled(ListItem)`
  background-color: ${({ selected, theme }) => selected && `#fafafa !important`};
  min-height: 50px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  margin-left: 5px;
`;

export const ListIcon = styled(ListItemIcon)`
  font-size: 23px;
  color: ${({ selected, theme }) => (selected ? theme.palette.secondary.main : 'white')};
  justify-content: center;
  margin-right: 2px;
  svg {
    position: relative;
    left: -2px;
  }
  @media only screen and (max-width: 1600px) {
    min-width: 52px;
  }
  @media only screen and (max-width: 1366px) {
    min-width: 44px;
  }
  @media only screen and (max-width: 1280px) {
    min-width: 38px;
  }
`;

export const ListText = styled(ListItemText)`
  flex: 1 1 auto;
  /* font-size: ${({ open }) => !open && 'none'}; */
  color: ${({ selected, theme }) => (selected ? theme.palette.primary.main : 'white')};
  @media only screen and (max-width: 992px) {
    span {
      font-size: 60%;
    }
  }
  @media only screen and (max-width: 768px) {
    span {
      font-size: 90%;
    }
  }
  span {
    font-weight: bold;
  }
`;

export const SubMenuIcon = styled(FontAwesomeIcon)`
  color: white;
  margin-right: 15px;
`;

export const SubListItem = styled(ListItem)`
  background-color: ${({ selected }) => selected && 'white !important'};
`;

export const LogoutItem = styled(ListItem)`
  svg {
    position: relative;
    left: 7px;
  }
`;

export const StyledList = styled(List)`
  height: 65%;

  @media only screen and (max-width: 1400px) {
    height: 55%;
  }
  @media only screen and (max-width: 600px) {
    height: 60%;
  }
`;
